import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private userDataSource = new BehaviorSubject<any>({});

  userData = this.userDataSource.asObservable();

  constructor() { }

  getUserData() {
    return this.userData;
  }

  setUserData(data: any) {
    this.userDataSource.next(data);
  }

}
